<template>
    <div class="main">
        <c-panel>
            <form-emprestimo v-on:onSubmitEmprestimo="onSubmitEmprestimo"></form-emprestimo>
        </c-panel>
    </div>
</template>
<script>
import formEmprestimo from "./form"

export default {
    methods:{
        onSubmitEmprestimo(){
            this.$router.push('/admin/biblioteca/emprestimo');
        }
    },
    components:{ formEmprestimo }
}
</script>

